import React from 'react';
import PropTypes from 'prop-types';
import { Result, Button } from 'antd';
import { Link } from 'react-router-dom';
import UserNotFound from './UserNotFound';
import UserDepartmentNotFound from './UserDepartmentNotFound';
import UserDisabled from './UserDisabled';
import NotAuthorisedInProject from './NotAuthorisedInProject';
import NotAuthorised from './NotAuthorised';
import Error404 from './Error404';
import SessionTimeout from './SessionTimeout';
import UserNoRole from './UserNoRole';

export {
  UserNotFound,
  UserDepartmentNotFound,
  UserDisabled,
  NotAuthorisedInProject,
  NotAuthorised,
  Error404,
  SessionTimeout,
  UserNoRole,
};

const ErrorPage = ({
  errorCode,
  title,
  subTitle,
  backPage,
  backButtonText,
  extra,
  ...rest
}) => {
  return (
    <Result
      {...rest}
      status={errorCode}
      title={title}
      subTitle={subTitle}
      extra={
        extra ? (
          extra
        ) : (
          <Button type="primary">
            <Link to={backPage}>{backButtonText}</Link>
          </Button>
        )
      }
    />
  );
};

ErrorPage.defaultProps = {
  backPage: '/home',
  backButtonText: 'Back Home',
  subTitle: 'Sorry, the page you visited does not exist.',
};

ErrorPage.propTypes = {
  errorCode: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  backPage: PropTypes.string.isRequired,
  backButtonText: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired,
  extra: PropTypes.arrayOf(PropTypes.node),
};

export default ErrorPage;
